export default "__VITE_ASSET__DiyXucPp__"